// converts given data(string) to a csv file and downloads the same
const exportCsvFromData = (data: any, fileName: string) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

// generate a string to create csv file from table headers and rows
const convertTableToCsvInput = (
  tableHeader: string[],
  tableRow: { key: string; value: any }[]
) => {
  const headerCsvString = tableHeader.join(',').concat('\n');
  const rowCsvString: string = tableRow
    .map((item: any) => {
      if (Object.keys(item).includes('feeCategoryData')) {
        delete item.feeCategoryData;
        delete item.amount;
      }
      const values = Object.values(item);
      return values.join(',');
    })
    .join('\n');
  return headerCsvString.concat(rowCsvString);
};

export { convertTableToCsvInput, exportCsvFromData };
